import { render, staticRenderFns } from "./DeleteComparisonDialog.vue?vue&type=template&id=8f621780&scoped=true&"
import script from "./DeleteComparisonDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteComparisonDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteComparisonDialog.vue?vue&type=style&index=0&id=8f621780&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f621780",
  null
  
)

export default component.exports